export default __webpack_public_path__ + "static/media/vacation_status.85e35e9b.svg";